module.exports = "/_next/static/images/PowerPersonalization@2x-a4cc3b72751bbc38d819cb9a1e7dde03.png";